import api from './api';
import { Product } from '../types/types';

export const productService = {
    // Get all products
    getAllProducts: async (): Promise<Product[]> => {
        const response = await api.get<Product[]>('/products');
        return response.data;
    },

    // Get product by ID
    getProductById: async (id: number): Promise<Product> => {
        const response = await api.get<Product>(`/products/${id}`);
        return response.data;
    },

    // Get low stock products
    getLowStockProducts: async (): Promise<Product[]> => {
        const response = await api.get<Product[]>('/products/low-stock');
        return response.data;
    },

    // Create new product
    createProduct: async (productData: Omit<Product, 'id'>): Promise<Product> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            Name: productData.name,
            Description: productData.description || '',
            Price: productData.price,
            Cost: productData.cost,
            Stock: productData.stock,
            IsActive: productData.isActive,
            CategoryId: productData.categoryId,
            Barcode: productData.barcode,
            ImageUrl: productData.imageUrl
        };
        const response = await api.post<Product>('/products', payload);
        return response.data;
    },

    // Update product
    updateProduct: async (id: number, productData: Product): Promise<void> => {
        // Map frontend property names to backend (PascalCase)
        const payload = {
            Id: id,
            Name: productData.name,
            Description: productData.description || '',
            Price: productData.price,
            Stock: productData.stock,
            Cost: productData.cost,
            IsActive: productData.isActive,
            CategoryId: productData.categoryId,
            Barcode: productData.barcode,
            ImageUrl: productData.imageUrl
        };
        await api.put(`/products/${id}`, payload);
    },

    // Delete product
    deleteProduct: async (id: number): Promise<void> => {
        await api.delete(`/products/${id}`);
    },
};
